export default __webpack_public_path__ + "static/1890-619ee28b8bfe4f881e9122bfdf55adee.gif";